import React from 'react';
import { Column } from '@ant-design/plots';

const ColumnChartBrokerServices = (props) => {
    const mockData = [
        { broker: 'Corretor A', appointments: 30 },
        { broker: 'Corretor B', appointments: 45 },
        { broker: 'Corretor C', appointments: 25 },
        { broker: 'Corretor D', appointments: 50 },
        { broker: 'Corretor E', appointments: 20 },
        { broker: 'Corretor F', appointments: 35 },
        { broker: 'Corretor G', appointments: 40 },
        { broker: 'Corretor H', appointments: 15 },
        { broker: 'Corretor I', appointments: 55 },
        { broker: 'Corretor J', appointments: 60 },
        { broker: 'Corretor K', appointments: 10 },
        { broker: 'Corretor L', appointments: 5 },
        { broker: 'Corretor M', appointments: 25 },
        { broker: 'Corretor N', appointments: 30 },
        { broker: 'Corretor O', appointments: 45 },
    ];

    const config = {
        data: mockData,
        xField: 'broker',
        yField: 'appointments',
        label: {
            position: 'middle',
            style: {
                fill: '#FFFFFF',
                opacity: 1,
            },
        },
        color: ({ broker }) => {
            const colors = ['#1E90FF', '#32CD32', '#FF4500', '#FFD700', '#8A2BE2', '#00CED1', '#FF69B4', '#CD5C5C', '#4B0082', '#7FFF00', '#DC143C', '#00FA9A', '#8B0000', '#FF8C00', '#00BFFF'];
            return colors[mockData.findIndex(item => item.broker === broker) % colors.length];
        },
        xAxis: {
            label: {
                autoHide: false,
                autoRotate: false,
            },
        },
        meta: {
            broker: {
                alias: 'Corretor',
            },
            appointments: {
                alias: 'Atendimentos',
            },
        },
        animation: false,
        height: 250,
    };
    return <Column {...config} />;
};

export default ColumnChartBrokerServices;